import type { SignSecret } from '../types/sign'

export * from './service'

export const sharedConfig = {
  // 基础请求路径
  httpBaseUrl: '/seaart_base',

  // 发布请求地址
  httpPublishUrl: '/publish',

  // 公共请求地址
  httpCommonUrl: '/common',

  // 源地址
  origin: __sharedEnv__.origin,

  googleClientId: __sharedEnv__.googleClientId,

  // 谷歌GTM ID
  gtmId: __sharedEnv__.gtmId,

  // Facebook App ID
  facebookAppId: __sharedEnv__.facebookAppId,

  // discord
  discordClientId: __sharedEnv__.discordClientId,

  //apple
  appleClientId: __sharedEnv__.appleClientId,

  // line
  lineClientId: __sharedEnv__.lineClientId,

  // 埋点
  trackSDKSrc: __sharedEnv__.trackSDKSrc,
  trackBaseUrl: __sharedEnv__.trackBaseUrl,
  trackSecretId: __sharedEnv__.trackSecretId,
  trackSecret: __sharedEnv__.trackSecret,
  trackAesKey: __sharedEnv__.trackAesKey,

  // 注入配置预留
  secret: undefined as SignSecret | undefined,
  clientId: undefined as string | undefined,
}

/**
 * 注入配置
 * @param config 配置对象
 */
export const injectSecretConfig = (secret: SignSecret) => {
  sharedConfig.secret = secret
}

/**
 * 注入客户端ID
 * @param clientId 客户端ID
 */
export const injectClientId = (clientId: string) => {
  sharedConfig.clientId = clientId
}

// console.debug('[sharedConfig] :>> ', sharedConfig)

export default sharedConfig
